import { render, staticRenderFns } from "./InputRadioOption.vue?vue&type=template&id=63909fdf&scoped=true&"
import script from "./InputRadioOption.vue?vue&type=script&lang=js&"
export * from "./InputRadioOption.vue?vue&type=script&lang=js&"
import style0 from "./InputRadioOption.vue?vue&type=style&index=0&id=63909fdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63909fdf",
  null
  
)

export default component.exports